// NavigationContext.js
import { createContext, useContext, useState } from 'react';

const NavigationContext = createContext();

export function NavigationProvider({ children }) {
  const [isFormDirtyCondition, setIsFormDirtyCondition] = useState(false);

  return (
    <NavigationContext.Provider value={{ isFormDirtyCondition, setIsFormDirtyCondition }}>
      {children}
    </NavigationContext.Provider>
  );
}

export function useNavigation() {
  return useContext(NavigationContext);
}